import { SupportFeedAttachmentDto } from '@api/ChallengeClient';

export const KNOWN_ATTACHMENT_LABELS: Record<string, string> = {
    journal_activity: 'Journal Activity',
    live_event: 'Live Event',
    new_challenge: 'New Challenge',
    duel: 'Duel'
};

export function csvEscape(value: string): string {
    return `"${value.replaceAll('"', '""')}"`;
}

export function collectImageUrls(
    attachments: SupportFeedAttachmentDto[]
): string[] {
    return Array.from(
        new Set(
            attachments.flatMap((attachment) =>
                [attachment.imageUrl, attachment.thumbUrl].filter(
                    (value): value is string => !!value
                )
            )
        )
    );
}

export function formatMetadataValue(value: unknown): string {
    if (typeof value === 'string') {
        return value;
    }

    if (
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        value === null
    ) {
        return String(value);
    }

    try {
        return JSON.stringify(value);
    } catch {
        return String(value);
    }
}
